import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import React from 'react';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import Image from 'next/image';
import Modal from 'react-modal';
import { useEffect, useState, useRef, useCallback } from 'react';
import Comment from './Comment';
import ModalHeader from '@/app/_components/modals/ModalHeader';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import { useProductComments } from '@/app/_hooks/useComment';

export default function CommentsImageModal({
  productId,
  selectedComment,
  openModal,
  onClose,
}) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [currentComment, setCurrentComment] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const { productCommentsInfo } = useProductComments(productId, 'image', 1);
  const comments = productCommentsInfo.data;

  useEffect(() => {
    if (openModal) {
      setInitialized(false);
      setTimeout(() => {
        setInitialized(true);
      }, 0); // Delay to ensure the DOM updates
    }
  }, [openModal]);

  const handleSlideChange = useCallback(
    (swiper) => {
      const currentSlideData =
        swiper.slides[swiper.activeIndex].getAttribute('data');
      setCurrentComment(
        comments.find((comment) => comment.id == currentSlideData)
      );
    },
    [comments]
  );

  useEffect(() => {
    if (selectedComment && comments.length > 0) {
      setCurrentComment(
        comments.find((comment) => comment.id == selectedComment)
      );
    }
  }, [selectedComment, comments]);

  useEffect(() => {
    if (initialized && swiperRef.current && selectedComment) {
      const swiperInstance = swiperRef.current.swiper;
      const selectedCommentIndex = comments.findIndex(
        (comment) => comment.id == selectedComment
      );

      if (selectedCommentIndex !== -1) {
        const slideIndex = comments
          .slice(0, selectedCommentIndex)
          .reduce((acc, comment) => acc + comment.images.length, 0);

        swiperInstance.slideTo(slideIndex, 0);
      }
    }
  }, [initialized, selectedComment, comments]);

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onClose}
      ariaHideApp={false}
      portalClassName="modalAddComment"
      className="commentModal"
      overlayClassName="modalOverlay"
      style={{
        content: {
          maxWidth: '872px',
          background: '#fff',
          border: '1px solid gray',
          height: '600px',
        },
      }}
    >
      <ModalHeader title={'دیدگاه ها'} CloseModal={onClose} />
      <div>
        <div className=" px-2 w-full h-full ">
          <div className="md:grid gap-4 flex flex-col flex-col-reverse h-full pb-28 md:pb-0 grid-cols-2 overflow-y-auto md:overflow-hidden">
            <div className="h-full overflow-y-auto">
              {currentComment && (
                <Comment comment={currentComment} notShowingImage={true} />
              )}
            </div>
            <div className="mt-2 h-[500px] overflow-auto  custom-scroll-bar relative">
              <>
                <Swiper
                  ref={swiperRef}
                  onSlideChange={handleSlideChange}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  modules={[Navigation]}
                >
                  {comments?.map((comment) => (
                    <React.Fragment key={comment.id}>
                      {comment.images.map((image, index) => (
                        <SwiperSlide
                          key={`${comment.id}-${index}`}
                          style={{ width: 'auto' }}
                          data={comment.id}
                        >
                          <Image
                            className="max-h-56 md:max-h-full w-auto mx-auto block"
                            src={image.full_path}
                            width={450}
                            height={450}
                          />
                        </SwiperSlide>
                      ))}
                    </React.Fragment>
                  ))}
                </Swiper>
                <div className="flex justify-between mt-4 rounded-md absolute w-full top-28 left-0 right-0 z-10">
                  <div
                    ref={nextRef}
                    className="bg-white px-1s cursor-pointer absolute left-0 py-1 rounded-md shadow-sm "
                  >
                    <CaretLeft />
                  </div>
                  <div
                    ref={prevRef}
                    className="bg-white cursor-pointer absolute px-1 right-0 py-1 rounded-md shadow-sm "
                  >
                    <CaretLeft className="rotate-180" />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
